module.exports = __webpack_public_path__ + "static/media/carousal_5.a3dc20d0.png";